import './style.css';
import { App } from './app.js';

/**
 * Boot: capability check → App. Failures land on a readable error screen instead
 * of a blank page.
 */

function fail(message: string, detail?: unknown): void {
  const box = document.getElementById('boot-error')!;
  const text = document.getElementById('boot-error-text')!;
  const det = document.getElementById('boot-error-detail')!;
  text.textContent = message;
  det.textContent = detail instanceof Error ? `${detail.message}\n${detail.stack ?? ''}` : String(detail ?? '');
  box.hidden = false;
}

function checkWebGL(): boolean {
  try {
    const canvas = document.createElement('canvas');
    return !!(canvas.getContext('webgl2') ?? canvas.getContext('webgl'));
  } catch {
    return false;
  }
}

try {
  if (!checkWebGL()) {
    fail(
      'VOIDLINE needs WebGL to render. Your browser or GPU driver has it disabled — try a recent Chrome, Edge or Firefox on the desktop.'
    );
  } else {
    const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;
    const uiRoot = document.getElementById('ui-root') as HTMLElement;
    const app = new App(uiRoot, canvas);
    // exposed for browser automation / debugging (harmless in production)
    (window as any).__voidline = app;
  }
} catch (err) {
  console.error(err);
  fail('VOIDLINE failed to start.', err);
}

// surface unexpected crashes readably rather than as a dead black screen
window.addEventListener('error', (e) => {
  if ((document.getElementById('boot-error') as HTMLElement).hidden === false) return;
  if (e.message?.includes('ResizeObserver')) return;
  console.error('uncaught', e.error);
});
